module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./EnterActivityView.js"));
	}, "EnterActivityView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EnterActivityView!./src/pages/Promote/OfflineActivity/EnterActivity/EnterActivityView.js
// module id = 1677
// module chunks = 418